// src/screens/mypage/EscapeDashboardScreen.js
// 47차: 탭바(총N회 도전, 탈출 성공 실패횟수 표시) 제거
//       상세 통계 카드들 유지, 기록 목록만 표시
// 51차: 디자인 토큰 단일화 — 색상 자체 정의 제거, theme.js COLORS 참조로 통일
//       (로직/레이아웃 변경 없음. 색값 동일 → 시각 변화 없음)
// 71차: ShareCard의 profile?.displayName(존재한 적 없는 필드) 죽은 폴백 제거
// 74차: 공유 카드에 남아있던 "RoomEscape" 표기 → "UNLOCK"으로 통일
// 74차: 화면 자체 커스텀 헤더 → 공통 AppHeader로 교체(공유/비공개 토글 버튼은 rightElement로 이동)
// 77차: design 폴더 "내 탈출 기록" 스펙 적용 — 성공률 카드에 골드 하이라이트 처리(테두리/배경 틴트),
// 기록 목록(RecordRow)을 아이콘박스+ESCAPED/FAILED 상태 뱃지 스타일로 교체, 최근 성공 기록엔
// 골드 틴트로 하이라이트. 이 화면은 목업(3-스탯)보다 실제 데이터가 훨씬 풍부해(힌트 분석/장르별
// 선호도/월별 추이/공유카드 등) 그 섹션들은 그대로 유지 — 순수 시각 스타일만 스펙에 맞춤.
// 77차: 74차 AppHeader 교체 시 제목 누락("‹ 뒤로"만 보이던 것 — "AppHeader 없음" 반복
// 신고 원인) 복원.
// 78차: 77차에 카드/배지 스타일만 반영하고 빠졌던 버튼 시스템 적용 — 통계 공개 전환/예약하러
// 가기/이미지 공유 3개 버튼(전부 인라인 골드 fill)을 공용 GradientButton(Primary)으로 교체.
// 성공/실패 pill 텍스트에 하드코딩돼 있던 색(#0b2417/#2a0f0c)도 theme.js의 onGreen/onRed
// 토큰으로 정리.

// 78차 32차: 공유 아이콘 전용 버튼에 accessibilityLabel 추가(접근성 라벨 전수 점검)
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, ScrollView, TouchableOpacity, StyleSheet,
  ActivityIndicator,
} from 'react-native';
import AppHeader from '../../components/common/AppHeader';
import GradientButton from '../../components/common/GradientButton';
import {
  EscapeSuccessIcon, MenuReservationIcon, ShareIcon, IconLabel,
  EscapeRecordSuccessIcon, EscapeRecordFailIcon, AvgEscapeTimeIcon,
  BestRecordIcon, HintUsageIcon, GenrePreferenceIcon, StatsVisibilityIcon,
  CheckmarkIcon, CancelIcon, MenuReviewIcon,
} from '../../components/common/Icons';
import { LogoMark } from '../../components/common/AppHeader';
import { doc, updateDoc } from 'firebase/firestore';
import ViewShot from 'react-native-view-shot';
import * as Sharing from 'expo-sharing';
import { db } from '../../services/firebase';
import { getMyReservations } from '../../services/reservationService';
import { useAuth } from '../../contexts/AuthContext';
import { COLORS } from '../../constants/theme';

const GOLD = COLORS.gold, BG = COLORS.bg, SURFACE = COLORS.surface, SURFACE2 = COLORS.surface2;
const BORDER = COLORS.border, TEXT = COLORS.text;
const TEXT_SEC = COLORS.textSec, TEXT_MUTED = COLORS.textMuted;
const GREEN = COLORS.green, RED = COLORS.red, ORANGE = COLORS.orange, BLUE = COLORS.blue, PURPLE = COLORS.purple;
const ON_GREEN = COLORS.onGreen, ON_RED = COLORS.onRed;

const CONTENT_H = 16;
const CARD_GAP  = 10;

const parseTimeToSeconds = (t) => {
  if (!t || typeof t !== 'string') return null;
  if (/^\d+분$/.test(t.trim())) return parseInt(t) * 60;
  const p = t.split(':').map(Number);
  if (p.length === 2) return p[0] * 60 + p[1];
  if (p.length === 3) return p[0] * 3600 + p[1] * 60 + p[2];
  return null;
};
const formatSeconds = (sec) => {
  if (sec == null) return '-';
  const m = Math.floor(sec / 60), s = sec % 60;
  return s > 0 ? `${m}분 ${s}초` : `${m}분`;
};

// 80차 후속: 체험형(정원제)은 탈출 성공/실패 개념이 없어 ESCAPED/FAILED 대신
// 중립적인 "관람 완료" 표시만 — success가 항상 null이라 방치하면 방탈출의
// "기록 없음"(결과 미입력) 문구가 잘못 붙어 보일 수 있어 별도 분기.
function RecordRow({ item, highlight }) {
  const isShow = item.bookingFormat === 'show';
  const ok   = item.success === true;
  const fail = item.success === false;
  return (
    <View style={[d.recordRow, highlight && d.recordRowHighlight]}>
      <View style={[d.recordIconBox, ok && d.recordIconBoxSuccess, fail && d.recordIconBoxFail, isShow && d.recordIconBoxShow]}>
        {isShow ? <CheckmarkIcon size={d.recordIconTxt.fontSize || 14} color={BLUE} />
          : ok ? <CheckmarkIcon size={d.recordIconTxt.fontSize || 14} color={GREEN} />
          : fail ? <CancelIcon size={d.recordIconTxt.fontSize || 14} color={RED} />
          : <Text style={d.recordIconTxt}>–</Text>}
      </View>
      <View style={{ flex: 1 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6 }}>
          <Text style={d.recordTheme} numberOfLines={1}>
            {item.themeName || item.productName || '테마 정보 없음'}
          </Text>
          {isShow && <View style={d.statusPillShow}><Text style={d.statusPillTxtShow}>관람 완료</Text></View>}
          {!isShow && ok && <View style={d.statusPillSuccess}><Text style={d.statusPillTxtSuccess}>ESCAPED</Text></View>}
          {!isShow && fail && <View style={d.statusPillFail}><Text style={d.statusPillTxtFail}>FAILED</Text></View>}
        </View>
        <Text style={d.recordMeta}>{item.date}{item.branchName ? `  ·  ${item.branchName}` : ''}</Text>
      </View>
      <View style={{ alignItems: 'flex-end', gap: 2 }}>
        {!isShow && item.escapeTime && ok  && <IconLabel Icon={AvgEscapeTimeIcon} size={12} color={GOLD} textStyle={[d.recordTime, { color: GOLD }]}>{item.escapeTime}</IconLabel>}
        {!isShow && item.hintCount != null && <Text style={d.recordHint}>힌트 {item.hintCount}회</Text>}
        {!isShow && !item.escapeTime && fail && <Text style={{ color: RED, fontSize: 11 }}>탈출 실패</Text>}
        {!isShow && item.success == null   && <Text style={{ color: TEXT_MUTED, fontSize: 11 }}>기록 없음</Text>}
      </View>
    </View>
  );
}

function GenreBar({ genre, count, max, successCount }) {
  const pct  = max > 0 ? (count / max) : 0;
  const rate = count > 0 ? Math.round((successCount / count) * 100) : 0;
  return (
    <View style={{ marginBottom: 12 }}>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 5 }}>
        <Text style={{ color: TEXT, fontSize: 13, fontWeight: '700' }}>{genre}</Text>
        <Text style={{ color: TEXT_MUTED, fontSize: 12 }}>
          {count}회 · 성공률{' '}
          <Text style={{ color: rate >= 50 ? GREEN : ORANGE, fontWeight: '700' }}>{rate}%</Text>
        </Text>
      </View>
      <View style={d.barBg}>
        <View style={[d.barFill, { width: `${Math.round(pct * 100)}%` }]} />
      </View>
    </View>
  );
}

function ShareCard({ profile, stats, showCount = 0 }) {
  const nickname = profile?.nickname || '탈출러';
  const rate     = stats.successRate;
  return (
    <View style={sc.card}>
      <View style={sc.header}>
        <Text style={sc.appName}>UNLOCK</Text>
        <Text style={sc.tagline}>나의 UNLOCK 기록</Text>
      </View>
      <Text style={sc.nickname}>{nickname}</Text>
      <View style={sc.row}>
        <View style={sc.statBox}>
          <LogoMark size={sc.statEmoji.fontSize || 22} />
          <Text style={sc.statVal}>{stats.total}</Text>
          <Text style={sc.statLbl}>총 도전</Text>
        </View>
        <View style={[sc.statBox, { borderColor: GREEN + '60' }]}>
          <EscapeRecordSuccessIcon size={22} color={GREEN} />
          <Text style={[sc.statVal, { color: GREEN }]}>{stats.success}</Text>
          <Text style={sc.statLbl}>탈출 성공</Text>
        </View>
        <View style={[sc.statBox, { borderColor: RED + '60' }]}>
          <EscapeRecordFailIcon size={22} color={RED} />
          <Text style={[sc.statVal, { color: RED }]}>{stats.fail}</Text>
          <Text style={sc.statLbl}>탈출 실패</Text>
        </View>
      </View>
      {rate !== null && (
        <View style={sc.rateWrap}>
          <View style={sc.rateRow}>
            <Text style={sc.rateLabel}>성공률</Text>
            <Text style={[sc.rateVal, { color: rate >= 50 ? GREEN : ORANGE }]}>
              {rate}%
            </Text>
          </View>
          <View style={sc.gaugeBg}>
            <View style={[sc.gaugeFill, {
              width:           `${rate}%`,
              backgroundColor: rate >= 50 ? GREEN : ORANGE,
            }]} />
          </View>
        </View>
      )}
      <View style={sc.subRow}>
        {stats.minTime !== null && (
          <View style={sc.subItem}>
            <BestRecordIcon size={20} />
            <Text style={sc.subVal}>{formatSeconds(stats.minTime)}</Text>
            <Text style={sc.subLbl}>최단 기록</Text>
          </View>
        )}
        {stats.avgHint !== null && (
          <View style={sc.subItem}>
            <HintUsageIcon size={20} />
            <Text style={sc.subVal}>{stats.avgHint}회</Text>
            <Text style={sc.subLbl}>평균 힌트</Text>
          </View>
        )}
        {stats.genres[0] && (
          <View style={sc.subItem}>
            <GenrePreferenceIcon size={20} />
            <Text style={sc.subVal} numberOfLines={1}>{stats.genres[0].name}</Text>
            <Text style={sc.subLbl}>선호 장르</Text>
          </View>
        )}
      </View>
      {/* 80차 후속: 공유 카드에 체험형 관람 기록이 아예 안 보인다는 신고 반영 */}
      {showCount > 0 && (
        <View style={sc.showNote}>
          <CheckmarkIcon size={14} color={BLUE} />
          <Text style={sc.showNoteText}>체험형 관람 {showCount}회</Text>
        </View>
      )}
      <Text style={sc.footer}>UNLOCK · {new Date().getFullYear()}</Text>
    </View>
  );
}

const sc = StyleSheet.create({
  // 80차 후속: width:SW-32(Dimensions.get('window').width 기준 고정 픽셀)가 웹에서는
  // 실제 표시 폭(App.js의 WebFrame이 75%로 제한)과 다른 "브라우저 창 전체 폭"으로 계산돼,
  // 오른쪽 통계 박스가 실제 보이는 영역 밖으로 잘려 보이던 버그(78차 68차의 halfCard와
  // 동일 유형) — 고정 픽셀 대신 부모 폭에 맞추는 상대값으로 교체.
  card:      { backgroundColor: SURFACE, borderRadius: 20, padding: 22,
               borderWidth: 1.5, borderColor: 'rgba(212,168,67,0.4)', width: '100%' },
  header:    { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 },
  appName:   { color: GOLD, fontSize: 16, fontWeight: '900', letterSpacing: 2 },
  tagline:   { color: TEXT_MUTED, fontSize: 11 },
  nickname:  { color: TEXT, fontSize: 22, fontWeight: '900', marginBottom: 18, letterSpacing: 0.5 },
  row:       { flexDirection: 'row', gap: 8, marginBottom: 16 },
  statBox:   { flex: 1, backgroundColor: SURFACE2, borderRadius: 12, padding: 12,
               alignItems: 'center', gap: 3, borderWidth: 1, borderColor: 'rgba(212,168,67,0.2)' },
  statEmoji: { fontSize: 20 },
  statVal:   { color: GOLD, fontSize: 20, fontWeight: '900' },
  statLbl:   { color: TEXT_MUTED, fontSize: 10, fontWeight: '600' },
  rateWrap:  { marginBottom: 16 },
  rateRow:   { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 6 },
  rateLabel: { color: TEXT_MUTED, fontSize: 12 },
  rateVal:   { fontSize: 13, fontWeight: '800' },
  gaugeBg:   { height: 8, backgroundColor: SURFACE2, borderRadius: 4, overflow: 'hidden' },
  gaugeFill: { height: 8, borderRadius: 4 },
  subRow:    { flexDirection: 'row', gap: 8, marginBottom: 18 },
  subItem:   { flex: 1, backgroundColor: SURFACE2, borderRadius: 10, padding: 10,
               alignItems: 'center', gap: 3 },
  subEmoji:  { fontSize: 16 },
  subVal:    { color: TEXT, fontSize: 13, fontWeight: '800' },
  subLbl:    { color: TEXT_MUTED, fontSize: 10 },
  footer:    { color: TEXT_MUTED, fontSize: 10, textAlign: 'center' },
  showNote:      { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 6,
                   backgroundColor: BLUE + '14', borderRadius: 10, borderWidth: 1, borderColor: BLUE + '30',
                   paddingVertical: 8, marginBottom: 10 },
  showNoteText:  { color: BLUE, fontSize: 12, fontWeight: '700' },
});

function MonthChart({ months }) {
  if (!months.length) return null;
  const maxVal = Math.max(...months.map(m => m.total), 1);
  return (
    <View style={{ flexDirection: 'row', alignItems: 'flex-end', gap: 6, height: 80 }}>
      {months.map(m => (
        <View key={m.month} style={{ flex: 1, alignItems: 'center', gap: 4 }}>
          <View style={{ flex: 1, justifyContent: 'flex-end', width: '100%' }}>
            <View style={{
              height: `${Math.max(8, Math.round((m.total / maxVal) * 100))}%`,
              backgroundColor: GOLD + '60',
              borderRadius: 4,
              overflow: 'hidden',
            }}>
              <View style={{
                height: m.total > 0 ? `${Math.round((m.success / m.total) * 100)}%` : '0%',
                backgroundColor: GREEN,
                borderRadius: 4,
                position: 'absolute',
                bottom: 0, left: 0, right: 0,
              }} />
            </View>
          </View>
          <Text style={{ color: TEXT_MUTED, fontSize: 9, fontWeight: '600' }}>
            {m.month.slice(5)}월
          </Text>
        </View>
      ))}
    </View>
  );
}

function PrivateModeNotice({ onDisable }) {
  return (
    <View style={d.privateBanner}>
      <View style={{ marginBottom: 10 }}><StatsVisibilityIcon size={32} /></View>
      <Text style={{ color: TEXT, fontSize: 15, fontWeight: '800', marginBottom: 6 }}>
        통계가 비공개 상태예요
      </Text>
      <Text style={{ color: TEXT_MUTED, fontSize: 13, textAlign: 'center', lineHeight: 19, marginBottom: 16 }}>
        장르별 선호도, 힌트 분석, 월별 추이 등{'\n'}상세 통계가 다른 사람에게 보이지 않아요.
      </Text>
      <GradientButton label="통계 공개로 전환" onPress={onDisable} textStyle={{ paddingHorizontal: 24 }} />
    </View>
  );
}

export default function EscapeDashboardScreen({ navigation }) {
  const { user, profile, refreshProfile } = useAuth();
  const [list,            setList]            = useState([]); // 방탈출(room) 전용 — 성공률/장르 등 상세 통계 계산에 사용
  const [showList,        setShowList]        = useState([]); // 80차 후속: 체험형(show) — 통계 없이 관람 횟수만 카운트
  const [loading,         setLoading]         = useState(true);
  const [togglingPrivate, setTogglingPrivate] = useState(false);
  const [sharing,         setSharing]         = useState(false);
  const viewShotRef = useRef(null);

  const statsPrivate = profile?.statsPrivate === true;

  useEffect(() => {
    getMyReservations(user.uid).then(data => {
      const now = new Date();
      // 78차 67차: r.date < today(달력일 기준)만 보고 있어서, 매장이 결과를 이미 입력한
      // "오늘" 방문 기록이 다음날까지 탈출기록에 안 잡히던 버그 — 결과가 입력됐으면
      // (success!=null) 종료로 간주, 아니면 예약 시작 시각 통과 여부로 판단.
      const isOccurred = (r) => r.success === true || r.success === false ||
        new Date(`${r.date}T${r.time || '00:00'}`) <= now;
      const occurred = data.filter(r => r.cancelled !== true && r.date && isOccurred(r));
      // 80차 후속: 체험형 공연(정원제)은 탈출 성공/실패 개념이 없어 성공률/장르 선호도 등
      // 상세 통계(genreMap 분모 등)에서 완전히 분리 — 대신 관람 횟수만 별도로 집계.
      setList(occurred.filter(r => r.bookingFormat !== 'show'));
      setShowList(occurred.filter(r => r.bookingFormat === 'show'));
    }).finally(() => setLoading(false));
  }, [user.uid]);

  const stats = useMemo(() => {
    const total    = list.length;
    const success  = list.filter(r => r.success === true);
    const fail     = list.filter(r => r.success === false);
    const recorded = list.filter(r => r.success != null);
    const reviewed = list.filter(r => r.reviewed === true);
    const times    = success.map(r => parseTimeToSeconds(r.escapeTime)).filter(t => t != null);
    const avgTime  = times.length ? Math.round(times.reduce((a,b)=>a+b,0)/times.length) : null;
    const minTime  = times.length ? Math.min(...times) : null;
    const hints    = recorded.map(r=>r.hintCount).filter(h=>h!=null&&!isNaN(h));
    const avgHint  = hints.length ? (hints.reduce((a,b)=>a+b,0)/hints.length).toFixed(1) : null;
    const zeroHint = hints.filter(h=>h===0).length;

    const genreMap = {};
    list.forEach(r => {
      const genre = r.genre || r.genres?.[0] || null;
      if (!genre) return;
      if (!genreMap[genre]) genreMap[genre] = { total:0, success:0 };
      genreMap[genre].total++;
      if (r.success === true) genreMap[genre].success++;
    });
    const genres = Object.entries(genreMap)
      .map(([name, v]) => ({ name, ...v }))
      .sort((a,b) => b.total - a.total)
      .slice(0, 5);

    const monthMap = {};
    const now = new Date();
    for (let i = 5; i >= 0; i--) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const key = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`;
      monthMap[key] = { month: key, total:0, success:0 };
    }
    list.forEach(r => {
      const month = (r.date || '').slice(0, 7);
      if (monthMap[month]) {
        monthMap[month].total++;
        if (r.success === true) monthMap[month].success++;
      }
    });
    const months = Object.values(monthMap);

    return {
      total, success: success.length, fail: fail.length,
      recorded: recorded.length, reviewed: reviewed.length,
      successRate: recorded.length ? Math.round((success.length/recorded.length)*100) : null,
      avgTime, minTime, avgHint, zeroHint, genres, months,
    };
  }, [list]);

  // 80차 후속: "전체 기록"은 방탈출+체험형을 합쳐 날짜 내림차순으로 — 체험형만 이용하는
  // 고객도 자기 활동 기록을 볼 수 있게(성공률 등 상세 통계 카드만 방탈출 전용으로 남김).
  const sortedList = useMemo(() => {
    return [...list, ...showList].sort((a, b) => (b.date||'').localeCompare(a.date||''));
  }, [list, showList]);

  const handleTogglePrivate = async () => {
    try {
      setTogglingPrivate(true);
      const next = !statsPrivate;
      await updateDoc(doc(db, 'users', user.uid), { statsPrivate: next });
      await refreshProfile();
    } catch (e) {
      showAlert('오류', e.message);
    } finally {
      setTogglingPrivate(false);
    }
  };

  const handleShare = async () => {
    if (!viewShotRef.current) return;
    try {
      setSharing(true);
      const uri = await viewShotRef.current.capture();
      const canShare = await Sharing.isAvailableAsync();
      if (!canShare) {
        showAlert('공유 불가', '이 기기에서는 공유 기능을 사용할 수 없습니다.');
        return;
      }
      await Sharing.shareAsync(uri, {
        mimeType: 'image/png',
        dialogTitle: '나의 UNLOCK 기록 공유',
      });
    } catch {
      showAlert('오류', '이미지 생성 중 오류가 발생했습니다.');
    } finally {
      setSharing(false);
    }
  };

  if (loading) return (
    <View style={{ flex:1, backgroundColor:BG, justifyContent:'center', alignItems:'center' }}>
      <ActivityIndicator size="large" color={GOLD} />
    </View>
  );

  return (
    <View style={d.container}>
      <AppHeader
        showBack
        centerElement={<Text style={{ color: COLORS.text, fontSize: 15, fontWeight: '800' }}>UNLOCK 기록</Text>}
        rightElement={
          <View style={{ flexDirection: 'row', gap: 8 }}>
            {/* 공유 카드는 방탈출 성공/실패 통계 프레이밍이라 체험형 전용 유저에게는 의미가 없어 room 기록 유무로만 게이트 */}
            {list.length > 0 && (
              <TouchableOpacity
                style={d.privacyBtn}
                onPress={handleShare}
                disabled={sharing}
                accessibilityLabel="공유하기"
                hitSlop={{ top:10, bottom:10, left:10, right:10 }}>
                {sharing
                  ? <ActivityIndicator size="small" color={GOLD} />
                  : <ShareIcon size={18} color={GOLD} />}
              </TouchableOpacity>
            )}
            <TouchableOpacity
              style={[d.privacyBtn, statsPrivate && d.privacyBtnActive]}
              onPress={handleTogglePrivate}
              disabled={togglingPrivate}
              hitSlop={{ top:10, bottom:10, left:10, right:10 }}>
              {togglingPrivate
                ? <ActivityIndicator size="small" color={statsPrivate ? GOLD : TEXT_MUTED} />
                : <StatsVisibilityIcon size={18} color={statsPrivate ? GOLD : TEXT_MUTED} />}
            </TouchableOpacity>
          </View>
        }
      />

      {(list.length === 0 && showList.length === 0) ? (
        <ScrollView contentContainerStyle={[d.scroll, { alignItems:'center', paddingTop:60 }]}>
          <EscapeSuccessIcon size={64} />
          <Text style={{ color:TEXT, fontSize:17, fontWeight:'800', marginTop:14, marginBottom:8 }}>아직 방문 기록이 없어요</Text>
          <Text style={{ color:TEXT_MUTED, fontSize:13, textAlign:'center', lineHeight:19, marginBottom:28 }}>
            {'예약 후 다녀오면\n여기서 나만의 기록을 확인할 수 있어요!'}
          </Text>
          <GradientButton
            label="🔍 예약하러 가기"
            onPress={() => navigation.navigate('Main', { screen: 'Booking' })}
            textStyle={{ paddingHorizontal: 36 }}
          />
        </ScrollView>
      ) : (
        <ScrollView contentContainerStyle={d.scroll} showsVerticalScrollIndicator={false}>

          {/* 80차 후속: 체험형(정원제)은 통계 없이 관람 횟수만 — 방탈출 전용 카드들과 섹션
              타이틀로 명확히 분리(혼합돼 보인다는 신고 반영), 항상 노출 */}
          {showList.length > 0 && (
            <View style={d.formatSection}>
              <Text style={d.formatSectionTitle}>체험형</Text>
              <View style={[d.sectionCard, { alignItems:'center', borderColor: BLUE+'40' }]}>
                <CheckmarkIcon size={22} color={BLUE} />
                <Text style={[d.cardValue, { color: BLUE, marginTop:6 }]}>{showList.length}회</Text>
                <Text style={d.cardLabel}>체험형 관람</Text>
              </View>
            </View>
          )}

          {list.length > 0 && (
          <View style={d.formatSection}>
          <Text style={d.formatSectionTitle}>방탈출</Text>
          {/* 요약 카드 행 — 47차: 탭바 제거, 카드는 유지 */}
          <View style={d.row}>
            <View style={[d.halfCard, { borderColor: GREEN+'40' }]}>
              <EscapeRecordSuccessIcon size={22} color={GREEN} />
              <Text style={[d.cardValue, { color: GREEN }]}>{stats.success}회</Text>
              <Text style={d.cardLabel}>탈출 성공</Text>
            </View>
            <View style={[d.halfCard, { borderColor: RED+'40' }]}>
              <EscapeRecordFailIcon size={22} color={RED} />
              <Text style={[d.cardValue, { color: RED }]}>{stats.fail}회</Text>
              <Text style={d.cardLabel}>탈출 실패</Text>
            </View>
          </View>

          {stats.successRate !== null && (
            <View style={[d.sectionCard, d.successRateCard, { marginBottom: CARD_GAP, alignItems:'center' }]}>
              <Text style={{ color: TEXT_MUTED, fontSize: 12, marginBottom: 4 }}>기록 등록 기준 성공률</Text>
              <Text style={{ color: COLORS.goldLight, fontSize: 32, fontWeight: '900' }}>
                {stats.successRate}%
              </Text>
            </View>
          )}

          <View style={d.row}>
            <View style={[d.halfCard, { borderColor: BLUE+'40' }]}>
              <AvgEscapeTimeIcon size={22} color={BLUE} />
              <Text style={[d.cardValue, { color: BLUE }]}>
                {stats.avgTime !== null ? formatSeconds(stats.avgTime) : '-'}
              </Text>
              <Text style={d.cardLabel}>평균 탈출</Text>
            </View>
            <View style={[d.halfCard, { borderColor: GOLD+'40' }]}>
              <BestRecordIcon size={22} color={GOLD} />
              <Text style={[d.cardValue, { color: GOLD }]}>
                {stats.minTime !== null ? formatSeconds(stats.minTime) : '-'}
              </Text>
              <Text style={d.cardLabel}>최단 기록</Text>
            </View>
          </View>

          {statsPrivate ? (
            <PrivateModeNotice onDisable={handleTogglePrivate} />
          ) : (
            <>
              {stats.avgHint !== null && (
                <View style={[d.sectionCard, { borderColor: PURPLE+'40' }]}>
                  <IconLabel Icon={HintUsageIcon} size={13} color={TEXT} textStyle={d.sectionCardTitle}>힌트 사용 분석</IconLabel>
                  <View style={d.row}>
                    <View style={[d.halfCard, { borderColor: PURPLE+'40' }]}>
                      <HintUsageIcon size={22} color={PURPLE} />
                      <Text style={[d.cardValue, { color: PURPLE }]}>{stats.avgHint}회</Text>
                      <Text style={d.cardLabel}>평균 힌트</Text>
                    </View>
                    <View style={[d.halfCard, { borderColor: GREEN+'40' }]}>
                      <Text style={d.cardEmoji}>🤫</Text>
                      <Text style={[d.cardValue, { color: GREEN }]}>{stats.zeroHint}회</Text>
                      <Text style={d.cardLabel}>힌트 0회</Text>
                    </View>
                  </View>
                </View>
              )}

              {stats.genres.length > 0 && (
                <View style={d.sectionCard}>
                  <IconLabel Icon={GenrePreferenceIcon} size={13} color={TEXT} textStyle={d.sectionCardTitle}>장르별 선호도</IconLabel>
                  {stats.genres.map(g => (
                    <GenreBar
                      key={g.name}
                      genre={g.name}
                      count={g.total}
                      max={stats.genres[0].total}
                      successCount={g.success}
                    />
                  ))}
                </View>
              )}

              <View style={d.sectionCard}>
                <IconLabel Icon={MenuReservationIcon} size={13} color={TEXT} textStyle={d.sectionCardTitle}>월별 도전 추이 (최근 6개월)</IconLabel>
                <MonthChart months={stats.months} />
                <View style={{ flexDirection:'row', gap:16, marginTop:10 }}>
                  <View style={{ flexDirection:'row', alignItems:'center', gap:5 }}>
                    <View style={{ width:10, height:10, borderRadius:2, backgroundColor:GREEN }} />
                    <Text style={{ color:TEXT_MUTED, fontSize:11 }}>성공</Text>
                  </View>
                  <View style={{ flexDirection:'row', alignItems:'center', gap:5 }}>
                    <View style={{ width:10, height:10, borderRadius:2, backgroundColor:GOLD+'60' }} />
                    <Text style={{ color:TEXT_MUTED, fontSize:11 }}>전체</Text>
                  </View>
                </View>
              </View>
            </>
          )}
          </View>
          )}

          <TouchableOpacity style={d.reviewLink} onPress={() => navigation.navigate('MyReviews')}>
            <View style={{ flex:1 }}>
              <IconLabel Icon={MenuReviewIcon} size={d.reviewLinkTitle.fontSize || 14} color={d.reviewLinkTitle.color} textStyle={d.reviewLinkTitle}>작성한 리뷰 {stats.reviewed}건</IconLabel>
              <Text style={d.reviewLinkSub}>내 리뷰 화면에서 자세히 보기</Text>
            </View>
            <Text style={{ color:GOLD, fontSize:20 }}>›</Text>
          </TouchableOpacity>

          {/* 전체 기록 목록 */}
          <View style={d.section}>
            <Text style={[d.sectionTitle, { marginBottom:14 }]}>
              전체 기록
              <Text style={{ color:TEXT_MUTED, fontSize:12, fontWeight:'400' }}> ({sortedList.length}건)</Text>
            </Text>
            {sortedList.length === 0 ? (
              <View style={{ alignItems:'center', paddingVertical:30 }}>
                <Text style={{ color:TEXT_MUTED, fontSize:13 }}>기록이 없습니다.</Text>
              </View>
            ) : (
              <View style={d.recordList}>
                {sortedList.map((item, idx) => (
                  <RecordRow key={item.id} item={item} highlight={idx === 0 && item.success === true} />
                ))}
              </View>
            )}
          </View>

          {stats.total > stats.recorded && (
            <View style={d.noRecordNotice}>
              <Text style={d.noRecordText}>
                💡 {stats.total - stats.recorded}건의 방문 기록이 아직 등록되지 않았어요.{'\n'}
                매장 방문 후 스태프에게 결과 등록을 요청해보세요!
              </Text>
            </View>
          )}

          {/* 공유 카드는 방탈출 성공/실패 통계 프레이밍이라 room 기록 유무로만 게이트 */}
          {list.length > 0 && (
          <View style={d.section}>
            <IconLabel Icon={ShareIcon} size={13} color={TEXT} textStyle={d.sectionTitle} style={{ marginBottom: 14 }}>기록 공유하기</IconLabel>
            <ViewShot ref={viewShotRef} options={{ format: 'png', quality: 1 }}>
              <ShareCard profile={profile} stats={stats} showCount={showList.length} />
            </ViewShot>
            <GradientButton
              label={sharing ? '공유 이미지 만드는 중...' : '📤 이미지로 공유하기'}
              onPress={handleShare}
              disabled={sharing}
              style={{ marginTop: 12 }}
            />
          </View>
          )}

          <View style={{ height: 40 }} />
        </ScrollView>
      )}
    </View>
  );
}

const d = StyleSheet.create({
  container:   { flex:1, backgroundColor:BG },
  scroll:      { padding: CONTENT_H },

  privacyBtn:       { width:38, height:38, borderRadius:10, borderWidth:1,
                      borderColor:BORDER, backgroundColor:SURFACE,
                      alignItems:'center', justifyContent:'center' },
  privacyBtnActive: { borderColor:GOLD+'60', backgroundColor:GOLD+'12' },

  privateBanner:   { backgroundColor:SURFACE, borderRadius:16, padding:24,
                     borderWidth:1, borderColor:GOLD+'30',
                     alignItems:'center', marginBottom:CARD_GAP },

  // 80차 후속: 방탈출/체험형 기록이 뒤섞여 보인다는 신고 — 각 형식 블록 위에 이 타이틀을
  // 붙여 시각적으로 명확히 구분(genre bar 등과 같은 sectionCardTitle과 동일 톤).
  formatSection:      { marginBottom: CARD_GAP },
  formatSectionTitle: { color:TEXT_MUTED, fontSize:12, fontWeight:'800', letterSpacing:0.5, marginBottom:8, textTransform:'uppercase' },
  row:      { flexDirection:'row', gap:CARD_GAP, marginBottom:CARD_GAP },
  // 78차 68차: width:HALF_W(Dimensions.get('window').width 기준 고정 픽셀)가 웹에서는
  // 실제 표시 폭(App.js의 WebFrame이 75%로 제한)과 다른 "브라우저 창 전체 폭"으로 계산돼,
  // 카드 두 개가 실제 보이는 영역보다 넓게 그려져 오른쪽이 잘려 보이던 버그 — flex:1로
  // 교체해 부모(row)의 실제 폭을 그대로 균등분배하도록 수정(네이티브 앱은 결과 동일).
  halfCard: { flex:1, backgroundColor:SURFACE, borderRadius:14,
              padding:14, borderWidth:1, borderColor:BORDER, alignItems:'center', gap:4 },
  cardEmoji: { fontSize:26, marginBottom:2 },
  cardValue: { color:TEXT, fontSize:20, fontWeight:'900' },
  cardLabel: { color:TEXT_MUTED, fontSize:11, fontWeight:'600', textAlign:'center' },

  sectionCard:      { backgroundColor:SURFACE, borderRadius:14, padding:16,
                      borderWidth:1, borderColor:BORDER, marginBottom:CARD_GAP },
  sectionCardTitle: { color:TEXT, fontSize:14, fontWeight:'800', marginBottom:14 },
  successRateCard:  { borderColor:'rgba(216,174,82,0.35)', backgroundColor:'rgba(216,174,82,0.05)' },

  barBg:   { height:7, backgroundColor:SURFACE2, borderRadius:4, overflow:'hidden' },
  barFill: { height:7, backgroundColor:GOLD, borderRadius:4 },

  reviewLink:      { flexDirection:'row', alignItems:'center', gap:12,
                     backgroundColor:SURFACE, borderRadius:14, padding:16,
                     borderWidth:1, borderColor:GOLD+'30', marginBottom:20 },
  reviewLinkTitle: { color:GOLD, fontWeight:'800', fontSize:14 },
  reviewLinkSub:   { color:TEXT_MUTED, fontSize:11, marginTop:2 },

  section:      { marginBottom:24 },
  sectionTitle: { color:TEXT, fontSize:15, fontWeight:'800' },

  recordList: { backgroundColor:SURFACE, borderRadius:14, borderWidth:1, borderColor:BORDER, overflow:'hidden' },
  recordRow:  { flexDirection:'row', alignItems:'center', gap:12, padding:14,
                borderBottomWidth:1, borderBottomColor:BORDER+'80' },
  recordRowHighlight: { backgroundColor:'rgba(216,174,82,0.06)' },
  recordIconBox:        { width:36, height:36, borderRadius:11, alignItems:'center', justifyContent:'center' },
  recordIconBoxSuccess: { backgroundColor:'rgba(111,191,142,0.12)' },
  recordIconBoxFail:    { backgroundColor:'rgba(205,111,102,0.12)' },
  recordIconBoxShow:    { backgroundColor: BLUE+'1F' },
  recordIconTxt: { fontSize:16, fontWeight:'700', color:TEXT_MUTED },
  recordTheme:{ color:TEXT, fontSize:13, fontWeight:'700', marginBottom:2 },
  recordMeta: { color:TEXT_MUTED, fontSize:11 },
  recordTime: { fontSize:11, fontWeight:'700' },
  recordHint: { color:ORANGE, fontSize:11 },
  statusPillSuccess:    { backgroundColor:GREEN, borderRadius:5, paddingVertical:2, paddingHorizontal:7 },
  statusPillTxtSuccess: { color:ON_GREEN, fontSize:10, fontWeight:'700' },
  statusPillFail:       { backgroundColor:RED, borderRadius:5, paddingVertical:2, paddingHorizontal:7 },
  statusPillTxtFail:    { color:ON_RED, fontSize:10, fontWeight:'700' },
  statusPillShow:       { backgroundColor:BLUE, borderRadius:5, paddingVertical:2, paddingHorizontal:7 },
  statusPillTxtShow:    { color:COLORS.bg, fontSize:10, fontWeight:'700' },

  noRecordNotice: { backgroundColor:GOLD+'0C', borderRadius:12, padding:14,
                    borderWidth:1, borderColor:GOLD+'25', marginBottom:8 },
  noRecordText:   { color:GOLD+'CC', fontSize:12, lineHeight:19, fontWeight:'600' },

});